export default __webpack_public_path__ + "fonts/info-green.svg";